// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__sT_NY","loader__spinner":"Loader_loader__spinner__UDzUg","rotate":"Loader_rotate__uTGm0"};